import Script from 'next/script';
import { useEffect } from 'react';

import { buildPixelInitScript } from '~/components/MetaPixel/pixelScript';
import { isMetaPixelEnabled } from '~/utils/meta/helpers';
import { captureFbclidToCookie } from '~/utils/meta/identifiers';

const PIXEL_ID = process.env.NEXT_PUBLIC_META_PIXEL_ID;

export const MetaPixel = () => {
  useEffect(() => {
    if (!isMetaPixelEnabled()) {
      return;
    }
    captureFbclidToCookie();
  }, []);

  if (!PIXEL_ID) {
    return null;
  }

  return (
    <Script
      id="meta-pixel-base"
      strategy="afterInteractive"
      // biome-ignore lint/security/noDangerouslySetInnerHtml: required to inject the Meta Pixel inline script
      dangerouslySetInnerHTML={{ __html: buildPixelInitScript(PIXEL_ID) }}
    />
  );
};
